import * as React from "react";
import styles from "./styles.scss";

const VisibleOnMobile = (props: React.PropsWithChildren<unknown>) => {
  return <span className={styles.root}>{props.children}</span>;
};

export default VisibleOnMobile;
